"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var react_1 = tslib_1.__importStar(require("react"));
var FAQ_1 = tslib_1.__importDefault(require("../FAQ"));
var WidgetVisualizer = /** @class */ (function (_super) {
    tslib_1.__extends(WidgetVisualizer, _super);
    function WidgetVisualizer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WidgetVisualizer.prototype.render = function () {
        var _a = this.props, data = _a.data, type = _a.data.type;
        return (react_1["default"].createElement(FAQ_1["default"], { data: {
                question: "<p>Widget bez naprogramovanej vizualiz\u00E1cie.<br /><b>Typ: " + type + "</b></p>",
                answer: "<div><pre style=\"overflow-wrap: break-word; white-space: pre-wrap\">" + JSON.stringify(data, null, 2) + "</pre></div>"
            } }));
    };
    return WidgetVisualizer;
}(react_1.PureComponent));
WidgetVisualizer.propTypes = {
    data: prop_types_1["default"].shape({
        type: prop_types_1["default"].string.isRequired
    }).isRequired
};
exports["default"] = WidgetVisualizer;
